var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refresh-button-container"},[_c('el-button',{attrs:{"circle":true},on:{"click":_vm.click}},[_c('svg-icon',{attrs:{"name":"refresh"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }